import { render, staticRenderFns } from "./InsuranceImport.vue?vue&type=template&id=3aa6cabe&scoped=true"
import script from "./InsuranceImport.vue?vue&type=script&lang=js"
export * from "./InsuranceImport.vue?vue&type=script&lang=js"
import style0 from "./InsuranceImport.vue?vue&type=style&index=0&id=3aa6cabe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6cabe",
  null
  
)

export default component.exports